import { k } from "../core/kaplay";
import { addButton, addTitle, addUiRoot } from "../ui/layout";

export function mountainScene() {
    const ui = addUiRoot();
    addTitle(ui, "Pick a course", -340, 80);
    addButton(ui, "Course 1  (green)", -180, () => k.go("game", { mode: "descent", course: 1 }));
    addButton(ui, "Course 2  (soon)", -60, () => {}, false);
    addButton(ui, "Course 3  (soon)", 60, () => {}, false);
    addButton(ui, "Freeride", 180, () => k.go("game", { mode: "freeride", course: null }));
    addButton(ui, "Back", 340, () => k.go("menu"));
    k.onKeyPress("escape", () => k.go("menu"));
}
